

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import { BanksContext } from '../../context/bank/BankContext';
import Message from '../../components/ui/Message';




export const BankPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isFormValid, setIsFormValid] = useState(false);
    const { countries, addBank, updateBank } = useContext(BanksContext);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    var bank;

    if (state) {
        bank = state.bank;
        if (bank.vault_id == null) {
            bank.vault_id = '';
        }
    } else {
        bank = {
            id: -1,
            code: '',
            name: '',
            country_code: '',
            // emails: '',
            // phones: '',
            // email_delivery: '',
            vault_id: ''
        }
    }


    const { formState, onInputChange } = useForm(bank);

    const { id, code, name, country_code, vault_id } = formState

    useEffect(() => {
        const formValid = code.length > 0 && name.length > 0 && country_code != '-1' && vault_id.length > 0
        setIsFormValid(formValid);
    }, [code, name, country_code, vault_id])



    const handleSave = async () => {
        var resp = "";
        if (id > 0) {
            resp = await updateBank(formState);
        } else {
            resp = await addBank(formState);
        }
        if (resp == "success") {
            setSuccessMessage(id > 0 ? "Banco actualizado correctamente" : "Banco creado correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{id > 0 ? 'Actualizar banco' : 'Crear banco'}</h3>
                <hr />

                <form className="row g-3 " >

                    <div className="mb-3">
                        <label htmlFor="countrySelect" className="form-label">País</label>
                        <select id='countrySelect' className="form-select" name='country_code' value={country_code} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {countries.length > 0
                                ?
                                countries.map(country => (
                                    <option key={country.code} value={country.code} selected={country.code == bank.country_code}>{country.name}</option>
                                ))
                                :
                                <option selected>No hay paises disponibles</option>
                            }
                        </select>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="bankNameInput" className="form-label">Nombre banco</label>
                        <input
                            id='bankNameInput'
                            type="text"
                            className={`form-control ${name ? 'is-valid' : 'is-invalid'}`}
                            placeholder="Nombre banco"
                            name="name"
                            value={name}
                            onChange={onInputChange}
                            required
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="bankCodeInput" className="form-label">Código banco</label>
                        <input
                            id='bankCodeInput'
                            type="text"
                            className={`form-control  ${code ? 'is-valid' : 'is-invalid'}`}
                            placeholder="Código banco"
                            name="code"
                            value={code}
                            onChange={onInputChange}

                            required
                        />
                    </div>


                    {/* <div className="mb-3">
                        <label htmlFor="emailInput" className="form-label">Correo contacto</label>
                        <input
                            id='emailInput'
                            type="text"
                            className={`form-control ${emails ? 'is-valid' : 'is-invalid'}`}
                            placeholder="Correo contacto"
                            name="emails"
                            value={emails}
                            onChange={onInputChange}
                            required
                        />
                    </div>


                    <div className="mb-3">
                        <label htmlFor="phoneInput" className="form-label">Teléfono contacto</label>
                        <input
                            id='phoneInput'
                            type="text"
                            className={`form-control 'is-valid'}`}
                            placeholder="Teléfono contacto"
                            name="phones"
                            value={phones}
                            onChange={onInputChange}
                            required
                        />
                    </div>


                    <div className="mb-3">
                        <label htmlFor="emailDeliveryInput" className="form-label">Correo envío</label>
                        <input
                            id='emailDeliveryInput'
                            type="text"
                            className={`form-control ${email_delivery ? 'is-valid' : 'is-invalid'}`}
                            placeholder="Ej. no-reply@beepay.inc"
                            name="email_delivery"
                            value={email_delivery}
                            onChange={onInputChange}
                            required
                        />
                    </div> */}

                    <div className="mb-3">
                        <label htmlFor="vaultIdInput" className="form-label">Credenciales dominio</label>
                        <input
                            id='vaultIdInput'
                            type="text"
                            className={`form-control ${vault_id ? 'is-valid' : 'is-invalid'}`}
                            placeholder="ocid1.vaultsecret.oc1.iad...."
                            name="vault_id"
                            value={vault_id}
                            onChange={onInputChange}
                            required
                        />
                    </div>


                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" disabled={!isFormValid}>Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
